import { normalizeUnit, parseConversion } from './itemUnitConversion';

const numberText = (value) => {
  if (value !== 0 && Math.abs(value) < 0.0000005) {
    return value < 0 ? '>-0.000001' : '<0.000001';
  }
  return value.toFixed(6).replace(/\.?0+$/, '');
};

const rawText = (quantity, unit) => {
  if (quantity == null || quantity === '') return '-';
  const amount = typeof quantity === 'number' && Number.isFinite(quantity)
    ? numberText(quantity)
    : String(quantity).trim();
  return [amount, unit].filter(Boolean).join(' ');
};

const matchingReference = (item, references, storeName) => {
  if (!Array.isArray(references)) return null;
  const candidates = references.filter((reference) =>
    reference?.name === item?.itemName &&
    (!storeName || !reference.store || reference.store === storeName)
  );
  return candidates.length === 1 ? candidates[0] : null;
};

export const readStoreItems = (responseData) => {
  if (Array.isArray(responseData?.items)) return responseData.items;
  if (Array.isArray(responseData?.consolidatedItems)) return responseData.consolidatedItems;
  return [];
};

export const formatInventoryDisplay = ({ item, references, storeName, preferPurchaseUnit = false }) => {
  const original = rawText(item?.quantity, item?.unit);
  const unavailable = { quantity: original, stock: `${original} (conversion unavailable)` };
  if (original === '-') return { quantity: original, stock: original };

  const quantity = typeof item.quantity === 'number' ? item.quantity : Number(item.quantity);
  if (!Number.isFinite(quantity) || quantity < 0 || !item.unit) return unavailable;

  const reference = matchingReference(item, references, storeName);
  if (!reference) return unavailable;

  let conversion;
  try {
    conversion = parseConversion(reference);
  } catch (_error) {
    return unavailable;
  }

  const unit = normalizeUnit(item.unit);
  if (unit === conversion.purchaseUnit) {
    return { quantity: original, stock: original };
  }
  if (unit !== conversion.usageUnit) return unavailable;

  const quotient = quantity / conversion.factor;
  if (!Number.isFinite(quotient) || !Number.isSafeInteger(Math.floor(quotient))) return unavailable;
  const major = Math.floor(quotient + Number.EPSILON * Math.max(1, quotient) * 4);
  const minor = Math.max(0, quantity - major * conversion.factor);
  const stock = `${major} ${conversion.purchaseUnit} ${numberText(minor)} ${conversion.usageUnit}`;
  const displayedQuantity = preferPurchaseUnit
    ? `${numberText(quantity / conversion.factor)} ${conversion.purchaseUnit}`
    : original;
  return { quantity: displayedQuantity, stock };
};
